<shared-toolbar title="Editor de correos">
  <button
    mat-icon-button
    matTooltip="Limpiar editor"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
  <mat-form-field
    subscriptSizing="dynamic"
    appearance="outline"
    class="w-18rem ml-5">
    <mat-label>Seleccione una plantilla</mat-label>
    <mat-select
      [formControl]="selectedControl"
      (selectionChange)="onSelectionChange($event)">
      @for (item of noti; track item) {
        <mat-option [value]="item.idTemplate">{{
          item.templateName
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <p class="font-medium ml-5">Plantilla Seleccionada: {{ selected }}</p>
  <div class="ml-8 mr-8">
    <form [formGroup]="editadoBuilding">
      <shared-text-area
        [labelTitle]="'Asunto'"
        [control]="$any(editadoBuilding.get('subject'))" />
      <shared-text-area
        [labelTitle]="'Saludo'"
        [control]="$any(editadoBuilding.get('salutation'))" />
      <shared-text-area
        [labelTitle]="'Mensaje'"
        [control]="$any(editadoBuilding.get('body'))" />
    </form>
  </div>
  <mat-card-content>
    <div class="grid mb-4">
      <div class="col flex gap-3 justify-content-end mt-3">
        <shared-button
          [icon]="'save'"
          [typeBtn]="'button'"
          (click)="update()"
          [disabled]="!editadoBuilding.valid"
          color="accent">
          Guardar
        </shared-button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
